export default __webpack_public_path__ + "static/media/dashboard-screen.16a361d1.png";